import * as z from "zod/v4";
import { selfServeOnboardingTimeSeriesSchema } from "../onboardings/get-self-serve-onboarding-time-series";
import { onboardingV2OverviewAnalyticsInputSchema } from "./overview-analytics-input";

export const getOnboardingsV2OverviewTimeSeries = {
  name: "getOnboardingsV2OverviewTimeSeries" as const,
  input: onboardingV2OverviewAnalyticsInputSchema,
  output: selfServeOnboardingTimeSeriesSchema,
};

export type GetOnboardingsV2OverviewTimeSeriesInput = z.infer<
  typeof getOnboardingsV2OverviewTimeSeries.input
>;
export type GetOnboardingsV2OverviewTimeSeriesOutput = z.infer<
  typeof getOnboardingsV2OverviewTimeSeries.output
>;
